require('./RASetGoalStepHeader.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const classnames = require('classnames');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { FormattedText } = require('core/i18n').i18n;

class RASetGoalStepHeader extends React.Component {
    buildResetButton() {
        return (
            <div className="ra-set-goal-step-header__button">
                <OKButton
                    modifier="ghost"
                    size="small"
                    leftIcon="icon-limpiar_objetivo"
                    onClick={this.props.resetStep} // eslint-disable-line
                >
                    <FormattedText value="raGlobal-raGlobal_resetGoalButton" />
                </OKButton>
            </div>
        );
    }

    render() {
        const { active, description, showButton, title } = this.props;
        const iconClass = classnames('ra-set-goal-step-header__icon', {
            'ra-set-goal-step-header__icon--active': !active,
            'ra-set-goal-step-header__icon--checked icon-exito': active,
        });
        const resetButton = showButton ? this.buildResetButton() : null;

        return (
            <div className="ra-set-goal-step-header">
                <i className={iconClass} />
                <div className="ra-set-goal-step-header__top-section-wrapper">
                    <div className="ra-set-goal-step-header__title">
                        {title}
                    </div>
                    {resetButton}
                </div>
                <div className="ra-set-goal-step-header__description">
                    {description}
                </div>
            </div>
        );
    }
}

// this.props.resetGoal

RASetGoalStepHeader.propTypes = {
    active: PropTypes.bool.isRequired,
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    resetStep: PropTypes.func,
    showButton: PropTypes.bool,
};

RASetGoalStepHeader.defaultProps = {
    showButton: false,
};

module.exports = RASetGoalStepHeader;
